import { Flex, Text, Button, useDisclosure } from "@chakra-ui/react";
import React from "react";
import { formatNumberLocal } from "../../../../helpers/formatNumberLocal";
import { useCurrentAccountStore } from "../../../../store/currentAccountStore";
import { OrderFilterSetting } from "../../../../types/order/orderQuery";
import { BulkEditModal } from "./bulkEdit/BulkEditModal";
import { DeleteAllTransactionsModal } from "./DeleteAllTransactionsModal";
import { DeleteSelectedTransactionsModal } from "./DeleteSelectedTransactionsModal";
import { useSelectedTxContext } from "./SelectedTxContext";

export function SelectedTransactionsActions({
  filters,
}: {
  filters: OrderFilterSetting;
}) {
  const accountId = useCurrentAccountStore(({ accountId }) => accountId);

  const {
    selectedCount,
    totalCount,
    selectAllPages,
    selectedIds,
    selectionState,
    clearAll,
  } = useSelectedTxContext();

  const isAnySelected = (selectedCount ?? 0) > 0;

  const bulkEditDisclosure = useDisclosure();

  const deleteSelectedTransactionsDisclosure = useDisclosure();

  const deleteAllTransactionsDisclosure = useDisclosure();

  if (!isAnySelected) {
    return null;
  }

  return (
    <Flex gap={2} wrap="wrap" p={2} backgroundColor="primary.25" align="center">
      <Text fontSize="sm">
        <Text as="span" color="primary.700" fontWeight="bold">
          {selectedCount?.toLocaleString()}
        </Text>{" "}
        selected
      </Text>
      {selectionState === "currentPage" && selectedCount !== totalCount && (
        <Button
          variant="ghost"
          colorScheme="gray"
          size="sm"
          onClick={() => {
            selectAllPages();
          }}
        >
          {`Select all ${formatNumberLocal(totalCount ?? 0)} transactions`}
        </Button>
      )}
      {selectionState === "allPages" && (
        <Button variant="ghost" colorScheme="gray" size="sm" onClick={clearAll}>
          Clear selection
        </Button>
      )}
      <Button
        variant="outline"
        colorScheme="gray"
        size="sm"
        onClick={bulkEditDisclosure.onOpen}
      >
        Edit
      </Button>
      {bulkEditDisclosure.isOpen && (
        <BulkEditModal
          disclosure={bulkEditDisclosure}
          filters={filters}
          selectedCount={selectedCount}
          selectedIds={selectedIds}
          clearSelected={clearAll}
        />
      )}
      {selectionState !== "allPages" && (
        // delete selected transactions on current page
        <>
          <Button
            variant="outline"
            colorScheme="red"
            size="sm"
            onClick={deleteSelectedTransactionsDisclosure.onOpen}
          >
            Delete
          </Button>
          {deleteSelectedTransactionsDisclosure.isOpen && (
            <DeleteSelectedTransactionsModal
              accountId={accountId}
              selectedCount={selectedCount}
              selectedIds={selectedIds}
              disclosure={deleteSelectedTransactionsDisclosure}
              clearSelected={clearAll}
            />
          )}
        </>
      )}
      {selectionState === "allPages" && (
        // Delete all transactions matching the filter across all pages
        <>
          <Button
            variant="outline"
            colorScheme="red"
            size="sm"
            onClick={deleteAllTransactionsDisclosure.onOpen}
          >
            Delete
          </Button>
          {deleteAllTransactionsDisclosure.isOpen && (
            <DeleteAllTransactionsModal
              selectedCount={selectedCount}
              disclosure={deleteAllTransactionsDisclosure}
              clearSelected={clearAll}
            />
          )}
        </>
      )}
    </Flex>
  );
}
